let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dKMly")).then(() => parcelRequire('3J7Zl'));